import { call, put, takeLatest, retry, all, select } from "redux-saga/effects";
import { apartmentActions } from "./reducer";
import { Apartment, Photo, Reviews } from "../../api/types";
import { apartmentsState } from "./selectors";
import {
  getApartments,
  getPhotos,
  getReviews,
  getVideo,
} from "../../api/endpoints";

const RETRY_LIMIT = 2;
const RETRY_DELAY = 2000; // 2 seconds delay between retries

function* getApartmentsSaga() {
  try {
    const res: Apartment[] = yield retry(
      RETRY_LIMIT,
      RETRY_DELAY,
      getApartments
    );
    yield put(apartmentActions.setApartments(res));
  } catch (error) {
    yield put(apartmentActions.toggleError(true));
    console.log("🚀 ~ function*getApartmentsSaga ~ error:", error);
  }
}

function* getVideosSaga() {
  try {
    const res: string = yield retry(RETRY_LIMIT, RETRY_DELAY, getVideo);
    yield put(apartmentActions.setVideoLink(res));
  } catch (error) {
    yield put(apartmentActions.toggleError(true));
    console.log("🚀 ~ function*getVideosSaga ~ error:", error);
  }
}

function* getPhotosSaga() {
  try {
    const res: Photo[] = yield retry(RETRY_LIMIT, RETRY_DELAY, getPhotos);
    yield put(apartmentActions.setPhotoContent(res));
  } catch (error) {
    yield put(apartmentActions.toggleError(true));
  }
}

function* getReviewsSaga() {
  try {
    const res: Reviews[] = yield retry(RETRY_LIMIT, RETRY_DELAY, getReviews);
    yield put(apartmentActions.setReviews(res));
  } catch (error) {
    yield put(apartmentActions.toggleError(true));
    console.log("🚀 ~ function*getReviewsSaga ~ error:", error);
  }
}

function* initSaga() {
  const state: ReturnType<typeof apartmentsState> = yield select(apartmentsState);
  const hasSeedData = (state.apartmentsList?.length ?? 0) > 0;
  if (!hasSeedData) {
    yield put(apartmentActions.toggleLoading(true));
  }

  yield call(getApartmentsSaga);
  yield call(getPhotosSaga);
  yield call(getVideosSaga);
  yield call(getReviewsSaga);

  yield put(apartmentActions.toggleLoading(false));
  yield put(apartmentActions.setInitialized(true));
}

export function* homeSaga() {
  yield takeLatest(
    apartmentActions.getApartments.toString(),
    getApartmentsSaga
  );
  yield takeLatest(apartmentActions.fetchPhotos.toString(), getVideosSaga);
  yield takeLatest(apartmentActions.fetchVideos.toString(), getPhotosSaga);
  yield takeLatest(apartmentActions.initApp.toString(), initSaga);
  yield takeLatest(apartmentActions.fetchReviews.toString(), getReviewsSaga);
}
